<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.0001 3.75H5.25006C4.42163 3.75 3.75006 4.42157 3.75006 5.24999L3.75001 14.7501C3.75 15.5786 4.42158 16.2501 5.25001 16.2501H14.7499C15.5784 16.2501 16.2499 15.5786 16.2499 14.7502L16.25 10.0001" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M7 13V10.7501M10.0001 13V8M13 13V11.2501" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M14.25 3.75V5.75M14.25 5.75V7.75M14.25 5.75H12.25M14.25 5.75H16.25" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'CreatePerformanceReportItemIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>